import { light_offer_extended } from "../models/light_offer_extended";

// DISCOUNT_TYPE_FIXED = 0
// DISCOUNT_TYPE_PERCENTAGE = 1

export default function isPercentageDiscountCoupon(
  offer: light_offer_extended,
): boolean {
  return offer.discount_type === 1;
}
